<template>
  <b-row>
    <b-col cols="4">
      <BfInput
        v-if="!allowSearch"
        label="Sucursal"
        data-key="sucursal"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.sucursal"
        :errors="errors"
        @update="updateForm"
      />
      <BfAutocomplete
        v-else
        label="Sucursal"
        data-key="sucursal"
        :value="data.sucursal"
        :fetch-suggestions="autocompleteSearch"
        :trigger-on-focus="false"
        :errors="errors"
        @input="selectOption"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="8">
     <BfInput
        label="Nombre"
        data-key="nombre"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.nombre"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <!--<b-col cols="6">
      <BfInput
        label="Sucursal asociada"
        data-key="sucursal_asociada"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.sucursal_asociada"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>-->
    <b-col cols="8">
      <BfInput
        label="Contacto entidad"
        data-key="contacto_persona"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.contacto_persona"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Teléfono entidad"
        data-key="contacto_telefono"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.contacto_telefono"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="8">
      <BfInput
        label="Correo electrónico"
        data-key="contacto_email"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.contacto_email"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Teléfono alternativo"
        data-key="contacto_telefono2"
        :edit-mode="editing"
        :readonly="readonly"
        :value="data.contacto_telefono2"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
  </b-row>
</template>

<script>
import { branchAPI } from '@/api';

export default {
  name: 'BranchForm',

  props: {
    allowSearch: {
      type: Boolean,
      default: false,
    },

    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },

    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      autocompleteOptions: [],
    };
  },

  methods: {
    async autocompleteSearch(query, cb) {
      if (query.length >= 2) {
        const {
          data: { data },
        } = await branchAPI.getAll({
          branch: query,
          perPage: 999,
        });

        this.autocompleteOptions = data;

        const formatted = data.map(branch => ({
          value: branch.sucursal,
        }));

        cb(formatted);
      }
    },

    selectOption(value) {
      const selected = this.autocompleteOptions.find(option => option.sucursal === value);

      this.$emit('select-search-item', selected);
    },

    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
  },
};
</script>
